import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const { t } = useTranslation();

  return (
    <nav aria-label="Breadcrumb" className="py-4">
      <ol className="flex items-center gap-1.5 text-sm flex-wrap">
        <li>
          <Link to="/" className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
            <i className="ri-home-4-line text-sm"></i>
            <span className="ml-1">{t('breadcrumb.home')}</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1.5">
            <i className="ri-arrow-right-s-line text-foreground-500 text-xs"></i>
            {item.to ? (
              <Link to={item.to} className="text-foreground-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-700 whitespace-nowrap">{item.label}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}